import { Button, FormControl, FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import React, { useContext, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PageContainer from '../../../Shared/Container/PageContainer';
import { useStyles } from './ChecklistDocumentUploadStyle';
import clsx from 'clsx';
import { useChecklistDocumentUploadService } from './ChecklistDocumentUploadService';
import AppContext from '../../../../AppContext';
import { useHistory } from 'react-router-dom';
import { translate } from '../../../../services/Translation/TranslationService';
import ChecklistDocumentUploadPreview from '../ChecklistDocumentUploadPreview/ChecklistDocumentUploadPreview';
import { useBrowserLocationState } from '../../../Shared/BrowserLocationState/BrowserLocationState';

export const testIds = {
  documentSelectedMenu: "document-selected-menu",
  fileUploadInput: "file-upload-input",
  cancelBtn: "cancel-btton"
}

/**
 * This component is responsible for displaying the normes
 */
const ChecklistDocumentUpload = () => {

  const currentLocationState = useBrowserLocationState<{audit: any, building: any, isReadonly: any, isNewDoc:any}>({keysRequired: ["audit", "building"]})

  const building = useMemo(
    () =>
      currentLocationState && currentLocationState.building
        ? currentLocationState.building
        : undefined,
    [currentLocationState],
  );
  const audit = useMemo(
    () => (currentLocationState?.audit ? currentLocationState?.audit : undefined),
    [currentLocationState],
  );
  const isReadonly = useMemo(
    () => (currentLocationState?.isReadonly ? currentLocationState?.isReadonly : false),
    [currentLocationState],
  );
  const isNewDoc = useMemo(
    () => (currentLocationState?.isNewDoc ? currentLocationState?.isNewDoc : false),
    [currentLocationState],
  );
  const category = useMemo(
    () => audit?.location_entity?.category_location,
    [audit],
  );
  const subCategory = useMemo(
    () => building?.sub_category_location,
    [building],
  );

  const { values, onChange, onSubmit, errors } = useChecklistDocumentUploadService(building, audit, isReadonly, isNewDoc)

  const classes = useStyles()
  const { t } = useTranslation();
  const { language } = useContext(AppContext);

  const errorsMessage: { file?: string } = useMemo(() => {
    const fileMessage = errors && errors.file === "required"
      ? t("adminDocument:fileUploadInputValidationRequired")
      : errors && errors.file === "type-pdf"
        ? t("adminDocument:fileUploadInputValidationTypePdf")
        : undefined
    return { file: fileMessage }
  }, [errors, t])

  const history = useHistory();
  const handleFormClose = useCallback(
    () => {
      history.goBack();

    }, [history]
  )
  return (
    <PageContainer>
      {
        <form onSubmit={onSubmit}>
          <h1>{isNewDoc ? t("checklistDocument:addTitleForm") : t("checklistDocument:updateTitleForm")}</h1>
          <Grid item lg={12} xs={12}>
            <Typography display="inline" className={classes.checklistDocTitle}>
              {`${building?.address?.street} ${building?.address?.house_number} ${building?.address?.city}`}
              {`, `}
              {!subCategory && category && translate(category, language)}
              {subCategory && translate(subCategory, language)}
            </Typography>
          </Grid>
          <Grid item lg={12} xs={12}>
            {building?.building_field_values?.map(fieldValue => (
              <Typography
                className={classes.checklistDocTitle}
                key={fieldValue.category_location_form_field_config_id}
                variant="subtitle1"
              >
                {translate(
                  fieldValue.category_location_form_field_config,
                  language,
                )}
                : {fieldValue.value}{' '}
              </Typography>
            ))}
          </Grid>
          <Grid
            container
            direction="column"
            justifyContent="space-evenly"
            alignItems="center"
            spacing={3}
          >
            <Grid
              item
              className={classes.control}
            >
              {/*Input label is outside form control because there are css problem between button for input (component label) and label itself*/}
              <InputLabel
                id="document-mix-select-label"
                className={clsx(classes.labelInputUploadFile, { [classes.error]: errors?.file !== undefined })}
              >{t("adminDocument:fileUploadInputLabel")}</InputLabel>
              <FormControl
                className={classes.control}
                error={errors?.file !== undefined ? true : false}
              >
                <div className={classes.containerInputUploadFile}>

                  <Button
                    variant="contained"
                    component="label"
                    className={classes.buttonUploadFile}
                  >
                    {t("adminDocument:selectFileButtonLabel")}
                    <input
                      data-testid={testIds.fileUploadInput}
                      id="document-upload"
                      name="document-upload"
                      aria-label="document-upload-label"
                      type="file"
                      accept="application/pdf"
                      onChange={onChange("file")}
                      hidden
                    />
                  </Button>
                  < Typography className={classes.fileName} variant="body1">{values.file ? values.file.name : t("adminDocument:noFileUploadMessage")}</Typography>
                </div>

                <FormHelperText>{errorsMessage.file
                  ? errorsMessage.file
                  : ""
                }</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item className={classes.control}>
              <Button
                type="submit"
                className={classes.buttonSubmit}
              >
                {isNewDoc ? t("checklistDocument:uploadNewDoc") : t("checklistDocument:modifyDoc")}
              </Button>
              <Button
                data-testid={testIds.cancelBtn}
                id="cancelUpdateBtn"
                onClick={() => handleFormClose()}
                variant="contained"
                color="default"
                fullWidth
              >
                {t("common:cancel")}
              </Button>
            </Grid>
          </Grid>
        </form>
      }
      {(building?.checklist_document[0]?.url || values) &&
        <ChecklistDocumentUploadPreview
          url={building?.checklist_document[0]?.url}
          values={values}
        />
      }
    </PageContainer>
  )
}

export default ChecklistDocumentUpload;
